import React, {useState} from 'react'
import {Button, Dialog, DialogTitle, DialogContent, OutlinedInput, DialogActions} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import axios from 'axios'
import { addSuccess, addError } from '../../components/Notifier'

export default function Feedback(props) {
    const {open, setOpen, title, appendix} = props
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState('');
    function submit()
    {
        setLoading(true);
        axios.post('/user/feedback', {}, {params: {message: text + '<br />' + appendix}}).then(resp => {
            setOpen(false);
            setLoading(false);
            setText('');
            addSuccess('Your feedback has been submitted. We will review it and get back to you shortly.')
        }).catch(err => {
            setLoading(false);
            addError('Network Error');
        }); 
    }

    return (
        <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <OutlinedInput 
            multiline
            style={{width: 270}}
            placeholder='Your reason for reporting (e.g. wrong notes, out of tune, etc.)'
            value={text}
            onChange={e => setText(e.target.value)}
            inputComponent="textarea"
            inputProps={{rows: 7}}
            autoComplete="off"
            name="feedback"
            size="small"  />
        </DialogContent>
        <DialogActions>
            <Button style={{width: 80, height: 35, borderRadius: 20, textTransform: 'none', marginRight: 20, marginBottom: 10}} variant="outlined" disableElevation onClick={() => setOpen(false)} disabled={loading}>Cancel</Button>
            <LoadingButton style={{width: 80, height: 35, borderRadius: 20, textTransform: 'none', marginRight: 10, marginBottom: 10}} variant="contained" disableElevation onClick={submit} disabled={text === '' || loading}>Submit</LoadingButton>
        </DialogActions>
        </Dialog>
    );
}
